import { initializeApp } from 'firebase/app';

// const firebaseConfig = {
//   apiKey: "AIzaSyCAbtfJ9DfSOfeNp1R5WlpUuWGMuaty1zA",
//   authDomain: "video-convert-project.firebaseapp.com",
//   projectId: "video-convert-project",
//   storageBucket: "video-convert-project.appspot.com",
//   messagingSenderId: "948943096703",
//   appId: "1:948943096703:web:f98a2f3140add3b783e84a"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCMXpq8b2upE1yka5MI7Vx9-p-6yaLsj2E",
  authDomain: "kurdishtalent-bfa78.firebaseapp.com",
  projectId: "kurdishtalent-bfa78",
  storageBucket: "kurdishtalent-bfa78.appspot.com",
  messagingSenderId: "48516816480",
  appId: "1:48516816480:web:f2dda9d9917d13b30c6d05"
};

 export const app = initializeApp(firebaseConfig);
 

 